<div class="wrapper p-2">
    <span class="document-name">{{documentName}}</span>
    <span class="document-size">{{documentSize}}</span>
    <div class="buttons">
        <div *ngIf="value.herkunftsnachweis != null && value.herkunftsnachweis != 'keine Angabe'" style="text-align: left; width: 100%">
            {{ value.herkunftsnachweis }}
        </div>
        <button [title]="'document.download' | translate" kendoButton class="download-button" *ngIf="isDownloadButtonVisible" (click)="onDownloadDocumentClick()" translate><i></i></button>
        <button [title]="'document.delete' | translate" kendoButton class="delete-button" *ngIf="isDeleteButtonVisible" (click)="onDeleteDocumentClick()"><i></i></button>
    </div>
</div>
